import { FASTElement as n, attr as r, volatile as d } from "@microsoft/fast-element";
import { avatarStyles as v } from "./avatar.styles.js";
import { avatarTemplate as c } from "./avatar.template.js";
import { toRem as f } from "../common/css-utils.js";
var g = Object.defineProperty, y = Object.getOwnPropertyDescriptor, s = (m, i, o, a) => {
  for (var e = a > 1 ? void 0 : a ? y(i, o) : i, p = m.length - 1, l; p >= 0; p--)
    (l = m[p]) && (e = (a ? l(i, o, e) : l(e)) || e);
  return a && e && g(i, o, e), e;
};
const h = class h extends n {
  get imageUrl() {
    return this.image || `https://api.dicebear.com/7.x/bottts/svg?seed=${this.seed}`;
  }
  invalidateSize(i) {
    this.size || (this.size = f(i));
  }
  //TODO when ::slotted(nova-avatar)::part(control) is supported, apply the style to the control directly
  // https://github.com/w3c/csswg-drafts/issues/3896
  sizeChanged() {
    this.invalidateSize(2.375), this.style.width = this.size, this.style.height = this.size;
  }
  connectedCallback() {
    super.connectedCallback(), this.invalidateSize(2.375), !this.image && !this.seed && (this.seed = "Nova");
  }
};
h.definition = {
  name: "avatar",
  template: () => c,
  styles: () => v
};
let t = h;
s([
  r
], t.prototype, "image", 2);
s([
  r
], t.prototype, "alt", 2);
s([
  r
], t.prototype, "seed", 2);
s([
  r
], t.prototype, "size", 2);
s([
  d
], t.prototype, "imageUrl", 1);
export {
  t as Avatar
};
